import * as React from 'react';

var MenuItemBadge = function MenuItemBadge(_ref) {
  var badge = _ref.badge;

  if (!badge) {
    return null;
  }

  return /*#__PURE__*/React.createElement("span", {
    className: "badge badge-".concat(badge.style, " badge-pill d-inline-flex ml-4p")
  }, /*#__PURE__*/React.createElement("span", {
    className: "indicator text-white mr-4p"
  }), badge.label);
};

export { MenuItemBadge };